import { render, staticRenderFns } from "./recommendPage.vue?vue&type=template&id=bf1d39c8&scoped=true&"
import script from "./recommendPage.vue?vue&type=script&lang=js&"
export * from "./recommendPage.vue?vue&type=script&lang=js&"
import style0 from "./recommendPage.vue?vue&type=style&index=0&id=bf1d39c8&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bf1d39c8",
  null
  
)

export default component.exports